module.exports = __webpack_public_path__ + "static/img/Bachelor_010665.0488789.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010665.jpg
// module id = 210
// module chunks = 0